import quoteGQLString from '../util/quoteGQLString';
import drugApprovalHistory from '../type/drugApprovalHistory';

export default (orgId) => `
    drugApprovalByOrg(org: ${quoteGQLString(orgId)}) {
        ${drugApprovalHistory()}
    }
`;
